import factorySmall from '../assets/images/services/factory-600.jpg';
import factoryLarge from '../assets/images/services/factory-1200.jpg';
import { FileText, Factory, ShieldCheck, Truck, ArrowRight } from 'lucide-react';
import service2Small from '../assets/images/services/european-delivery-600.jpg';
import service2Large from '../assets/images/services/european-delivery-1200.jpg';
import service1Small from '../assets/images/services/quality-check-600.jpg';
import service1Large from '../assets/images/services/quality-check-1200.jpg';
import service0Small from '../assets/images/services/special-orders-600.jpg';
import service0Large from '../assets/images/services/special-orders-1200.jpg';
import { useI18n } from '../i18n/LanguageContext';
import { Link } from 'react-router-dom';






const Services=()=>{
  const { t } = useI18n();

    return (
<div className="servicesPage">

  {/* ===== HERO ===== */}
  <section className="servicesHero">
    <h1>{t("Custom Sourcing & Quality Control")}</h1>
    <p>
      {t("Need a specific component, machine, or custom electronics set? We handle sourcing, inspection, and secure shipping to Europe.")}</p>
  </section>


  {/* ===== MAIN SERVICES ===== */}
  <section className="servicesGrid">

    <div className="serviceCard">
      <img className="serviceIllustration" src={service0Large} srcSet={`${service0Small} 600w, ${service0Large} 1200w`} sizes="(max-width: 760px) 92vw, 350px" alt={t("Special Component Orders")} loading="lazy"/>
      <div className="serviceCardCopy"><h3>{t("Special Component Orders")}</h3>
      <p>
        {t("We source hard-to-find electronics, custom kits, and bulk component sets directly from verified manufacturers.")}</p></div>
    </div>

    <div className="serviceCard">
      <img className="serviceIllustration" src={service1Large} srcSet={`${service1Small} 600w, ${service1Large} 1200w`} sizes="(max-width: 760px) 92vw, 350px" alt={t("Pre-Shipment Quality Check")} loading="lazy"/>
      <div className="serviceCardCopy"><h3>{t("Pre-Shipment Quality Check")}</h3>
      <p>
        {t("Every special order can be inspected by our team before leaving Asia. We verify functionality, packaging, and compliance before export.")}</p></div>
    </div>

    <div className="serviceCard">
      <img className="serviceIllustration" src={service2Large} srcSet={`${service2Small} 600w, ${service2Large} 1200w`} sizes="(max-width: 760px) 92vw, 350px" alt={t("Secure European Delivery")} loading="lazy"/>
      <div className="serviceCardCopy"><h3>{t("Secure European Delivery")}</h3>
      <p>
        {t("Consolidated shipping, customs handled, and delivery from France without surprises or hidden fees.")}</p></div>
    </div>

  </section>


  {/* ===== HOW IT WORKS ===== */}
  <section className="processSection">

    <h2>{t("How It Works")}</h2>

    <ol className="processSteps">
      {[
        { Icon: FileText, color: 'blue', text: 'You send us your specifications or product references.' },
        { Icon: Factory, color: 'purple', text: 'We source from trusted factories and confirm pricing.' },
        { Icon: ShieldCheck, color: 'green', text: 'Quality control inspection before shipment.' },
        { Icon: Truck, color: 'orange', text: 'Fast and secure delivery to Europe.' },
      ].map(({ Icon, color, text }, index) => <li className="processStep" key={text}>
        <div className={`processNode ${color}`}><Icon size={27} strokeWidth={1.7} aria-hidden="true"/><span className="processNumber">0{index + 1}</span></div>
        <p>{t(text)}</p>
        {index < 3 && <span className="processConnector" aria-hidden="true"><ArrowRight size={16}/></span>}
      </li>)}
    </ol>

  </section>


  {/* ===== OPTIONAL PREMIUM SERVICE ===== */}
  <section className="premiumSection factoryVerification">
    <img className="factoryVerificationPhoto" src={factoryLarge} srcSet={`${factorySmall} 600w, ${factoryLarge} 1200w`} sizes="(max-width: 760px) 92vw, 480px" width={1200} height={683} alt={t("On-Site Factory Verification (Optional)")} loading="lazy"/>
    <div className="factoryVerificationCopy">

    <h2>{t("On-Site Factory Verification (Optional)")}</h2>
    <p>
      {t("For high-value orders or machinery, we can organize on-site factory visits for in-person verification and production checks.")}</p>
    </div>

  </section>


  {/* ===== CTA ===== */}
  <section className="servicesCTA">

    <h2>{t("Need a Custom Order?")}</h2>
    <p>
      {t("Tell us what you need. We’ll discuss sourcing, quantities, and delivery by email.")}</p>

    <Link className="button primary" to="/contact?reason=custom-order">{t("Discuss your order")}</Link>

  </section>

</div>
    )
}

export default Services;